import { FC, ReactNode } from 'react';
import { Box, SxProps, Theme, useTheme } from '@mui/material';

interface Props {
  children?: ReactNode;
  sx?: SxProps<Theme>;
}

const SortContainer: FC<Props> = ({ children, sx }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        my: theme.spacing(2),
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default SortContainer;
